import { formatDKAddress } from '@debbie/common/dist/addresses/adressevaelger.js';
import { EBoksRecipientType } from '@debbie/common/dist/interactions/eboks.js';
import { useDKAddress } from '@debbie/cortex/dist/addresses/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { APIBASE } from '../../config.js';
import THEME from '../../theme.js';
import { FileText } from '../Icons/index.js';
import { Modal } from '../index.js';
import ObjectComp from '../ObjectComp.js';
import DefaultSummary from './DefaultSummary.js';
const EBoksSummary = (props) => {
    const [openPDF, setOpenPDF] = useState(false);
    const eboks = props.interaction.details;
    const lang = useSelector((s) => s.lang);
    const recipientAddress = useDKAddress(eboks.recipient.type === EBoksRecipientType.AddressId
        ? eboks.recipient.addressId
        : null);
    return (React.createElement(DefaultSummary, { transparrent: !openPDF, ...props, metaData: [
            {
                header: lang.interactions.to,
                body: (React.createElement(React.Fragment, null, eboks.recipient.type === EBoksRecipientType.CentralRegisterId ? (React.createElement(HighlightedRecipient, null,
                    eboks.recipient.isCompany ? 'CVR' : 'CPR',
                    ":",
                    ' ',
                    eboks.recipient.centralRegisterId)) : eboks.recipient.type === EBoksRecipientType.KVHX ? (React.createElement(React.Fragment, null,
                    React.createElement(HighlightedRecipient, null, eboks.recipient.firstName),
                    ' ',
                    React.createElement(HighlightedRecipient, null, eboks.recipient.lastName),
                    ' ',
                    React.createElement(HighlightedRecipient, null, eboks.recipient.kvhx))) : eboks.recipient.type === EBoksRecipientType.AddressId ? (React.createElement(React.Fragment, null,
                    React.createElement(HighlightedRecipient, null, eboks.recipient.firstName),
                    ' ',
                    React.createElement(HighlightedRecipient, null, eboks.recipient.lastName),
                    h.hasData(recipientAddress) &&
                        recipientAddress.data !== null && (React.createElement(React.Fragment, null,
                        ' ',
                        React.createElement(HighlightedRecipient, null, formatDKAddress(recipientAddress.data)))))) : null)),
            },
        ] },
        React.createElement(ShowPDFButton, { onClick: () => setOpenPDF(!openPDF) },
            React.createElement(FileText, { size: 14 }),
            lang.interactions.seeDocument),
        openPDF && (React.createElement(Modal, { header: lang.interactionTypes.EBOKS, onToggle: () => {
                setOpenPDF(!openPDF);
            } },
            React.createElement(ObjectComp, { type: "application/pdf", url: `${APIBASE}/files/${eboks.pdf}/debbie.pdf` })))));
};
export default EBoksSummary;
const ShowPDFButton = styled.p `
  background: none;
  border: none;
  cursor: pointer;
  color: ${THEME.COLOR_ACCENT};
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.85em;
  padding: 0;
  margin-bottom: 0;
  margin-top: 0;

  &:hover {
    text-decoration: underline;
  }
`;
const HighlightedRecipient = styled.span `
  background-color: ${THEME.SURFACE_MUTED};
  border-radius: 5px;
  padding: 4px 6px;
  font-size: 0.7em;
`;
//# sourceMappingURL=EBoksSummary.js.map